import { render, staticRenderFns } from "./UserPackageStatusView.vue?vue&type=template&id=b1e0dfd0&"
import script from "./UserPackageStatusView.vue?vue&type=script&lang=js&"
export * from "./UserPackageStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports